module.exports = __webpack_public_path__ + "img/firework-left.43f7ea9e.svg";